'use strict';
// Зависимости: jQuery, class-extend.js

/**
 * Предоставляет инструменты для работы с Агентом веб-доступа.
 * Например, запустить или отключить Агент веб-доступа.
 *
 * @class AgentCore
 * @since 5.0.0.4100
 */

(function(global) {
  var LOG_LEVEL = {
    ERROR: 0,
    WARN: 1,
    INFO: 2,
    DEBUG: 3
  };

  var AgentCore = Class.extend({
    _availablePlugins: {},
    _abstractMethodWarning: 'Should not be used directly. Must be overriden.',
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    init: function() {
      this._availablePlugins = {};
    },

    /**
     * Проверяет, включен ли запрет на использование и запуск Агента веб-доступа.
     *
     * @abstract
     * @method AgentCore#isDisabled
     * @return {boolean} True – запрет на использование и запуск Агент веб-доступа включен, иначе False.
     * @since 5.1.0.1511
     */
    isDisabled: function() {
      this.log.warn(this._abstractMethodWarning);
      return false;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Проверяет, доступен ли Агент веб-доступа.
     *
     * @abstract
     * @method AgentCore#isAvailable
     * @return {boolean} True – Агент веб-доступа доступен для работы, иначе False.
     *
     * @example
     * if (AgentCore.isAvailable()) {
     *  alert('На текущем компьютере Агент веб-доступа установлен и доступен для работы.');
     * };
     */
    isAvailable: function() {
      this.log.warn(this._abstractMethodWarning);
      return true;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Проверяет, доступен ли плагин Агента веб-доступа.
     *
     * @method AgentCore#isPluginAvailable
     * @param {string} pluginName Имя плагина
     * @param {string} sessionId ID сессии пользователя.
     * @return {Deferred<boolean>} True – плагин Агента веб-доступа доступен для работы, иначе False.
     * @see https://api.jquery.com/category/deferred-object/
     *
     * @example
     * AgentCore.isPluginAvailable('edmsplugin', g_UserContextID).done(function(res){
     *   if (res)
     *     alert('Плагин Агента веб-доступа доступен для работы с EDMS-объектами системы DIRECTUM');
     * });
     */
    isPluginAvailable: function(pluginName, sessionId) {
      var d = $.Deferred();

      var me = this;
      var params = {
        'name': pluginName,
        'SessionID': sessionId
      };

      if (typeof me._availablePlugins[pluginName] !== 'undefined') {
        d.resolve(me._availablePlugins[pluginName]);
        return d.promise();
      }

      //Шамов А.: Если тут проверять запущен или нет, то тогда мы не покажем диалог "Подождать еще", т.к. он будет не запущен и ВД будет работать без него. Например, в быстрых действиях.
      if (me.isAvailable()) {
        me.transmitRequest('IsPluginAvailable', '', params)
          .done(function (response) {
            var booleanResult = (response.result === 'true');
            me._availablePlugins[pluginName] = booleanResult;
            d.resolve(booleanResult);
          })
          .fail(function (response) {
            if (response.result === 'RESTARTING') {
              me._availablePlugins = {};
            } else {
              me._availablePlugins[pluginName] = false;
            }
            d.reject(false);
          });
      } else {
        me._availablePlugins[pluginName] = false;
        d.reject(false);
      }

      return d.promise();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Отправляет запрос Агенту веб-доступа, используя доступный транспорт.
     * Транспорт – это один из механизмов для взаимодействия с Агентом веб-доступа. Например, NPAPI-транспорт или HTTP-транспорт.
     *
     * @method AgentCore#transmitRequest
     * @param {string} requestName Имя запроса
     * @param {string} pluginName Имя плагина Агента, к которому идет обращение.
     * Для базовых вызовов к ядру Агента веб-доступа передается пустая строка
     * @param {Object} params Параметры запроса.
     * @param {string} sessionId ID сессии пользователя (передается, если не указана в параметрах).
     * @param {Object} extraParams Дополнительные параметры запроса (например, timeout)
     * @return {Deferred<Object>} Результат запроса.
     * @see https://api.jquery.com/category/deferred-object/
     *
     * @example
     * AgentCore.transmitRequest('PING','',{}).done(function(response){
     *   console.log(response) //  Object { message="PONG", success=true}
     * });
     */
    transmitRequest: function(requestName, pluginName, params, sessionId, extraParams) {
      var me = this;
      var d = $.Deferred();

      // Если ID сессии был передан явно через параметры метода - дописываем его в объект params.
      if (sessionId) params.SessionID = sessionId;

      me.log.debug('AGENT: "transmitRequest" method "' + requestName + '" was called');

      if (me.isDisabled()) {
        me.log.debug('AGENT: Agent is disabled');
        d.reject({ message: null, success: false });
      }

      global.agentCore.transport.transmitRequest(requestName, pluginName, params, extraParams).always(function(respObj) {
        me.log.info('AGENT: Response of "transmitRequest" method "' + requestName + '": ', respObj);
      }).done(function (respObj) {
        d.resolve(respObj);
      }).fail(function (respObj) {
        d.reject(respObj);
      });

      return d.promise();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Запускает Агент веб-доступа.
     *
     * @method AgentCore#start
     * @param {string} sessionId ID сессии пользователя.
     * @return {Object} Отложенный (deferred) объект.
     * @since 5.1.0.1500
     */
    start: function(sessionId) {
      this._availablePlugins = {};
      return global.agentCore.transport.start(sessionId);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Останавливает работу Агента веб-доступа.
     * Используется для повторного соединения веб-страницы с Агентом веб-доступа.
     *
     * @method AgentCore#stop
     * @return {AgentCore} Объект типа agent.
     */
    stop: function() {
      this._availablePlugins = {};
      global.AgentCore.transport.stop();
      return global.agent;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Перезапускает Агент веб-доступа.
     *
     * @method AgentCore#restart
     * @param {string} sessionId ID сессии пользователя.
     * @return {AgentCore} Объект типа agent.
     */
    restart: function(sessionId) {
      this._availablePlugins = {};
      return global.agentCore.transport.restart(sessionId);
    },

    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Отменяет запуск Агента веб-доступа.
     *
     * @method AgentCore#cancelStart
     * @return {AgentCore} Объект типа agent.
     */
    cancelStart: function() {
      this._availablePlugins = {};
      global.agentCore.transport.cancelStart();
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Проверяет, запущен ли Агент веб-доступа. Делает attemptNumber попыток.
     *
     * @method AgentCore#checkSessionState
     * @param {number} attemptNumber Количество попыток
     * @param {string} sessionId ID сессии пользователя.
     * @param {function} callbackWhenNotRegistered Функция, вызываемая если регистрация сессии отклонена агентом.
     * @return {Deferred<Object>} Объект с результатом запуска.
     * @see https://api.jquery.com/category/deferred-object/
     */
    checkSessionState: function(attemptNumber, sessionId, callbackWhenNotRegistered) {
      if (attemptNumber < 1) attemptNumber = 1;
      return this._checkSessionStateLoop($.Deferred(), 0, sessionId, attemptNumber, callbackWhenNotRegistered);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Циклично проверяет, запущен ли Агент веб-доступа. Делает maxAttemptNumber попыток.
     *
     * @method AgentCore#_checkSessionStateLoop
     * @private
     * @param {Object} def Отложенный объект.
     * @param {number} attemptIndex Индекс попытки.
     * @param {string} sessionId ID сессии пользователя.
     * @param {number} maxAttemptNumber Максимальное количество попыток.
     * @param {function} callbackWhenNotRegistered Функция, вызываемая если регистрация сессии отклонена агентом.
     * @return {Object} Отложенный (deferred) объект с результатом запуска.
     */
    // Проверяет запущен ли агент. Делает несколько попыток.
    _checkSessionStateLoop: function(def, attemptIndex, sessionId, maxAttemptNumber, callbackWhenNotRegistered) {
      var me = this;
      // Если агент не запущен, то сам transmitRequest будет по таймауту висеть.
      me.transmitRequest('GetSessionRegistrationStatus', '', { 'SessionID': sessionId }).done(function (pingResponse) {
        if (pingResponse.result === 'REGISTERED') {
          me.log.info('AGENT: Session successfully registered by agent');
          def.resolve(true);
        } else if (pingResponse.result === 'PROXIED') {
          me.log.info('AGENT: Agent operates by using the service.');
          if (localStorage.getItem('agentHttpPort') === null) {
            me.transmitRequest('GetWorkingPorts', '', { 'SessionID': sessionId }).done(function (ports) {
              if (ports.result.length) {
                const [ httpPort,  httpsPort ] = [ ports.result[0], ports.result[1] ];
                me.log.info('AGENT: Agent httpPort=' + httpPort + '; httpsPort=' + httpsPort);
                localStorage.setItem('agentHttpPort', httpPort);
                localStorage.setItem('agentHttpsPort', httpsPort);
              }
            });
          }
          def.resolve(true);
        } else if (pingResponse.result === 'NOTREGISTERED') {
          me.log.info('AGENT: Session registration rejected by agent');
          def.resolve(false);
          if (typeof callbackWhenNotRegistered === 'function') callbackWhenNotRegistered();
        }
      }).fail(function(pingResponse) {
        if (pingResponse.result === 'ERR_INVALID_SESSION_ID') {
          if (localStorage.getItem('agentHttpPort') !== null) {
            localStorage.removeItem('agentHttpPort');
            localStorage.removeItem('agentHttpsPort');
          }
          def.reject(true);
        } else {
          if (attemptIndex < maxAttemptNumber) {
            me._checkSessionStateLoop(def, attemptIndex + 1, sessionId, maxAttemptNumber, callbackWhenNotRegistered);
          } else {
            def.reject();
          }
        }
      });

      return def;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Очищает кэш доступных плагинов Агента веб-доступа.
     *
     * @method AgentCore#clearPluginCache
     */
    clearPluginCache: function () {
      this._availablePlugins = {};
    },

    /**
     * Выгружает лог-файлы Агента на сервер веб-доступа.
     *
     * @method AgentCore#uploadLogs
     * @param {number} token Токен для операции диагностики.
     * @param {string} sessionId ID сессии пользователя.
     * @return {Deferred<Object>} Результат выполнения запроса.
     * @see https://api.jquery.com/category/deferred-object/
     */
    uploadLogs: function(token, sessionId) {
      var d = $.Deferred();

      var params = {
        'IsSecured': (document.location.protocol === 'http:' ? 'n' : 'y'),
        'Host': document.location.host,
        'ClientAffinity': ($.cookie('ARRAffinity') == null ? '' : $.cookie('ARRAffinity')),
        'Token': token,
        'SessionID': sessionId
      };

      this.transmitRequest('GetLogs', '', params).done(function (response) {
        if (response.success === true) {
          d.resolve(response);
        } else {
          d.reject(response);
        }
      }).fail(function(response) {
        d.reject(response);
      });

      return d.promise();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Проверить наличие обновлений для Агента веб-доступа.
     *
     * @method AgentCore#checkUpdates
     * @param {number} token Токен для операции диагностики
     * @param {string} sessionId ID сессии пользователя.
     * @return {Deferred<boolean>} True – Агент веб-доступа имеет одно или несколько обновлений, иначе False.
     * @see https://api.jquery.com/category/deferred-object/
     */
    checkUpdates: function(token, sessionId) {
      var d = $.Deferred();
      var params = {
        'IsSecured': (document.location.protocol === 'http:' ? 'n' : 'y'),
        'Host': document.location.host,
        'Token': token,
        'ClientAffinity': ($.cookie('ARRAffinity') == null ? '' : $.cookie('ARRAffinity')),
        'SessionID': sessionId
      };

      this.transmitRequest('CheckUpdates', '', params).done(function(response) {
        if (response.result === 'YES') {
          d.resolve(response.result);
        } else {
          d.reject(response.result);
        }
      }).fail(function() {
        d.reject();
      });

      return d.promise();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Получить информацию о прогрессе загрузки обновления Агента веб-доступа.
     * Рассчитывается в процентах.
     *
     * @method AgentCore#getUpdateProgress
     * @param {string} sessionId ID сессии пользователя.
     * @return {number} Процент загруженного обновления.
     */
    getUpdateProgress: function(sessionId) {
      return this.transmitRequest('GetUpdateProgress', '', { 'SessionID': sessionId });
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Поддерживает жизнь сессии Агента веб-доступа.
     *
     * @method AgentCore#keepAlive
     * @param {string} sessionId ID сессии пользователя.
     * @return {AgentCore} Объект типа AgentCore.
     */
    keepAlive: function(sessionId) {
      return this.transmitRequest('PING', '', { 'SessionID': sessionId });
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Начинает новую сессию для агента.
     *
     * @method AgentCore.beginSession
     * @param {Object} params Параметры сессии:
     * @param {string} params.UserLanguage Культура пользователя (например, Ru).
     * @param {string} params.UserName Имя пользователя.
     * @param {string} params.SystemLanguage
     * @param {string} params.SessionID ID сессии пользователя.
     * @param {string} params.System
     * @param {string} params.IsSecured True если протокол http, иначе - False.
     * @param {string} params.Host
     * @param {string} params.WebLinkServer
     * @param {string} params.SessionUpdateTime
     * @param {string} params.MaxRequestLength
     * @param {string} params.NewJobsNotificationToken Токен
     * @param {string} params.ClientAffinity
     * @return {Deferred<Object>} Результат выполнения запроса.
     * @see https://api.jquery.com/category/deferred-object/
     */
    beginSession: function(params) {
      var me = this;
      var d = $.Deferred();
      me.log.info('AGENT: "beginSession" method was called');

      //Отправляем параметры новой сессии агенту
      me.transmitRequest('BeginSession', '', params).done(function(res) {
        d.resolve(res);
      }).fail(function(res) {
        if (!!res) {
          me.log.error('AGENT: Error in beginSession response: ' + res.message);
        }
        d.reject(res);
      });

      return d.promise();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Заканчивает сессию для агента.
     *
     * @method AgentCore#endSession
     * @param {string} sessionId ID сессии пользователя.
     * @return {(string|object)}
     */
    endSession: function(sessionId) {
      var me = this;
      var response = '';

      //Отправляем параметры новой сессии агенту
      this.transmitRequest('EndSession', '', { 'SessionID': sessionId }).fail(function(res) {
        if (!!res) {
          me.log.error('AGENT: Error in endSession response: ' + res.message);
        }
        response = res;
      });

      return response;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
     * Устанавливает языковые настройки текущей сессии Агента веб-доступа.
     *
     * @method AgentCore#setLanguage
     * @param {string} language Текущий язык. Возможные значения: ru, en
     * @param {string} sessionId ID сессии пользователя.
     * @return {AgentCore} Объект типа AgentCore.
     */
    setLanguage: function(language, sessionId) {
      this.transmitRequest('SetLanguage', '', { 'Language': language, 'SessionID': sessionId });
      return this;
    },

    /**
     * Вывод отладочных сообщений
     *
     * @since 5.6
     */
    log: {
      _level: window && window.localStorage && parseInt(localStorage.getItem('agent.log.level')) || LOG_LEVEL.INFO,
      error: function (err) {
        if (this._level >= LOG_LEVEL.ERROR) {
          console.log('ERROR: ' + err);
        }
      },
      warn: function (err) {
        if (this._level >= LOG_LEVEL.WARN) {
          console.log('WARN: ' + err);
        }
      },
      info: function (err) {
        if (this._level >= LOG_LEVEL.INFO) {
          console.log('INFO: ' + err);
        }
      },
      debug: function (err) {
        if (this._level >= LOG_LEVEL.DEBUG) {
          console.log('DEBUG: ' + err);
        }
      },
      /**
       * Устанавливает уровень логгирования.
       *
       * @method AgentCore.log#setLevel
       * @param {number} level Уровень логгирования (ERROR: 0, WARN: 1, INFO: 2, DEBUG: 3)
       */
      setLevel: function(level) {
        localStorage.setItem('agent.log.level', this._level = level);
      }
    }
  });

  global.agentCore = new AgentCore();
  global.agentCore.Agent = AgentCore;

})(window);
